import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { DarkOne, lastOne, LightDark, Lightight, smallLighterText } from "../../Assets/CSS/Text";
import { Ctnbtn } from "../../Assets/CSS/Button";
import toast from "react-hot-toast";
import axios from "axios";

const SalaryStructure = ({ empData, setActiveTab }) => {
    const [loading, setLoading] = useState(false);
    const [salaryData, setSalaryData] = useState(null);
    const [ctcAmount, setCtcAmount] = useState("");
    // const [components, setComponents] = useState([]);
    const employeeId = empData.potentialEmployeeId;
    // useEffect(() => {
    //     fetchSalaryComponent();
    // }, [])

    // useEffect(() => {
    //     if (!salaryData || components.length === 0) return;

    //     setComponents(prev =>
    //         prev.map(comp => {
    //             // ✅ Set CTC
    //             if (comp.componentName === "CTC") {
    //                 return {
    //                     ...comp,
    //                     annual: Number(salaryData.ctcOfEmployee || 0),
    //                     perMonth: Math.round(Number(salaryData.ctcOfEmployee || 0) / 12),
    //                 };
    //             }

    //             // ✅ Match by component NAME
    //             const amount = salaryData.salaryComponents?.[comp.componentName];

    //             if (amount !== undefined) {
    //                 return {
    //                     ...comp,
    //                     annual: Number(amount),
    //                     perMonth: Math.round(Number(amount) / 12),
    //                 };
    //             }

    //             return comp;
    //         })
    //     );
    // }, [salaryData, components.length]);


    useEffect(() => {
        if (!employeeId) return;

        const fetchSalaryData = async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem("token");

                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/potential-employees/${employeeId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                setSalaryData(res.data);
            }
            catch (err) {
                //     toast.error("Failed to load employee data");

                // ✅ NO SALARY YET → normal case
                if (err.response?.status === 404 || err.response?.status === 400) {
                    setSalaryData(null);   // allow CREATE
                    return;
                }

                // ❌ REAL error
                // toast.error("Failed to load employee data");
            }
            finally {
                setLoading(false);
            }
        };

        fetchSalaryData();
    }, [employeeId]);





    // const updateAnnual = (id, value) => {
    //     setComponents(prev =>
    //         prev.map(item =>
    //             item.salaryComponentId === id
    //                 ? {
    //                     ...item,
    //                     annual: Number(value),
    //                     perMonth: Math.round(Number(value) / 12)
    //                 }
    //                 : item
    //         )
    //     );
    // };





    // const totalAnnual = components
    //     .filter(item => item.componentName !== "CTC")
    //     .reduce((sum, item) => sum + Number(item.annual || 0), 0);

    // // Monthly In-Hand (approx)
    // const monthlyInHand = Math.round(totalAnnual / 12);

    // const fetchSalaryComponent = async () => {
    //     try {
    //         const token = localStorage.getItem('token');
    //         setLoading(true);

    //         const response = await axios.get(
    //             `${process.env.REACT_APP_BACKEND_URL}/api/v1/salary-components`,
    //             { headers: { Authorization: `Bearer ${token}` } }
    //         );



    //         // setComponents(response.data);
    //         setComponents(
    //             response.data.map(item => ({
    //                 ...item,
    //                 perMonth: Number(item.perMonth),
    //                 annual: Number(item.annual)
    //             }))
    //         );

    //     }
    //     // catch (error) {
    //     //     console.log(error.message);
    //     // } 
    //     catch (err) {
    //         //     toast.error("Failed to load employee data");

    //         // ✅ NO SALARY YET → normal case
    //         if (err.response?.status === 404 || err.response?.status === 400) {
    //             setSalaryData(null);   // allow CREATE
    //             return;
    //         }

    //         // ❌ REAL error
    //         // toast.error("Failed to load employee data");
    //     }
    //     finally {
    //         setLoading(false);
    //     }
    // };



    const handleSubmit = async () => {
        try {
            if (!ctcAmount || Number(ctcAmount) <= 0) {
                toast.error("Please enter CTC amount");
                return;
            }
            setLoading(true);
            const token = localStorage.getItem("token");
            // 🔴 BASIC EMPTY CHECK
            // const hasAnyValue = components.some(
            //     item => Number(item.annual) > 0
            // );

            // if (!hasAnyValue) {
            //     toast.error("Please enter salary values before generating appointment letter");
            //     return;
            // }
            // const filteredComponents = components.filter(
            //     item => item.componentName !== "CTC"
            // );

            // const totalComponentAnnual = filteredComponents.reduce(
            //     (sum, item) => sum + Number(item.annual || 0),
            //     0
            // );

            // const ctc = Number(
            //     components.find(c => c.componentName === "CTC")?.annual
            // );

            // if (totalComponentAnnual !== ctc) {
            //     toast.error(
            //         `Salary breakup total (${totalComponentAnnual}) must match CTC (${ctc})`
            //     );
            //     return;
            // }

            const payload = {
                employeeId,
                ctcAmount: Number(ctcAmount), // ✅ ALREADY ANNUAL
                // components: filteredComponents.map(item => ({
                //     componentId: item.salaryComponentId,
                //     amount: Number(item.annual) // ✅ ALREADY ANNUAL
                // })),
                // "deductions": []

            };

            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/salary/assign`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            setActiveTab("letter");
            toast.success("Salary assigned successfully");

        } catch (error) {
            toast.error(error.response?.data?.message || "Submission failed");
        } finally {
            setLoading(false);
        }
    };



    const isSalaryAssigned = Boolean(
        salaryData?.ctcOfEmployee &&
        Object.keys(salaryData?.salaryComponents || {}).length > 0
    );

    return (
        <div className="container py-0" style={{ maxWidth: "900px" }}>
            <p style={Lightight}>Generate offer letter with salary structure and annexures</p>

            <h5 className="mb-4" style={lastOne}>Salary Breakdown</h5>



            <div className="row g-3">
                <div className="col-md-6 mb-4">

                    <label className="form-label d-flex justify-content-between">
                        <span style={LightDark}>CTC</span>
                        <small style={smallLighterText}>Annual</small>
                    </label>

                    <div className="d-flex gap-2">
                        <input
                            type="number"
                            className="form-control"
                            style={{
                                textAlign: "right",
                                borderRadius: "8px",
                                height: "52px",
                                fontWeight: "600",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={ctcAmount}
                            onChange={(e) => setCtcAmount(e.target.value)}
                        />


                    </div>
                </div>
                <div>
                    <button
                        className=" px-4  continue-btn" style={Ctnbtn}
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? "Loading..." : "Breakdown"}
                    </button>
                </div>


            </div>




            {/* Total Card */}
            {/* <div
                className="p-4 mt-4 border rounded-3"
                style={{ background: "#F0FFF4", borderColor: "#38C172" }}
            >
                <h6 className="d-flex justify-content-between">
                    <span style={DarkOne}>Total Annual Package</span>
                    <span className="fw-bold">₹{totalAnnual.toLocaleString("en-IN")}</span>
                </h6>

                <p className="d-flex justify-content-between mt-2 mb-0">
                    <span style={LightDark}>Monthly In-hand (Approx.)</span>
                    <span className="fw-bold">₹{monthlyInHand.toLocaleString("en-IN")}</span>
                </p>
            </div> */}

            {/* Send Button */}
            {/* <button className=" mt-4 px-4 mb-3  continue-btn" style={Ctnbtn}
                onClick={() => {
                    if (isSalaryAssigned) {
                        setActiveTab("letter") // 👈 NO API CALL
                    } else {
                        handleSubmit(); // 👈 POST API
                    }
                }}
            >
                Generate Appointment Letter
            </button> */}
        </div>
    );
};

export default SalaryStructure;

// {components.map((item) => {
//                     const isCTC = item.componentName === "CTC";

//                     return (
//                         <React.Fragment key={item.salaryComponentId}>
//                             {/* PF – left column */}
//                             <div className={`col-md-6 ${isCTC ? "mb-4" : ""}`}>
//                                 <label className="form-label d-flex justify-content-between">
//                                     <span style={LightDark}>{item.componentName}</span>

//                                     <small style={smallLighterText}>
//                                         {isCTC ? "Annual" : `₹${item.perMonth}/month`}
//                                     </small>
//                                 </label>

//                                 <input
//                                     type="number"
//                                     className="form-control"
//                                     style={{
//                                         textAlign: "right",
//                                         borderRadius: "8px",
//                                         height: isCTC ? "52px" : "40px",
//                                         fontWeight: isCTC ? "600" : "400",
//                                         backgroundColor: isCTC ? "#F9FAFB" : "#FFFFFF"
//                                     }}
//                                     value={item.annual}
//                                     onChange={(e) =>
//                                         updateAnnual(item.salaryComponentId, e.target.value)
//                                     }
//                                 />
//                             </div>

//                             {/* Empty column ONLY for PF */}
//                             {isCTC && <div className="col-md-6" />}
//                         </React.Fragment>
//                     );
//                 })}